import { useDesktopProfileSync } from "../hooks/use-desktop-profile-sync";

/**
 * Always-mounted (desktop only) host for profile side effects that need
 * UserProvider. Keep sync out of Menu.Dropdown so it runs without opening
 * the user menu.
 */
export function DesktopProfileEffects() {
	if (!window.electronAPI?.isElectron) {
		return null;
	}

	return <DesktopProfileSyncHost />;
}

function DesktopProfileSyncHost() {
	useDesktopProfileSync();
	return null;
}
